<template>
    <div class="mark col999" :class="{'arrow2': !spuShow}">
        销售区域
        <div class="item" @click="onArea">
            <span v-text="addressName"></span>
        </div>
        <areaList
            ref="area"
            v-if="showValue"
            title='查看销售区域'
            confirmText='关闭'
            :showValue='showValue'
            :citiyValue="areaArray.cityId"
            :areaData='areaList'
        />
    </div>
</template>
<script>
import areaList from '../area'
import { getBusinessArea } from '../../api/api'
import { mapActions, mapGetters } from 'vuex'
export default {
    components: {
        areaList
    },
    props: {
        spuSalesAreaList: {
            type: Array,
            default: () => []
        },
        spuShow: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            addressName: '',
            areaData: '',
            areaArray: '',
            countryId: '',
            showValue: false,
            userInfo: '',
            areaList: {}
        }
    },
    computed: {
        ...mapGetters(['getAreaList'])
    },
    methods: {
        ...mapActions(['getArea']),
        onArea () {
            if (this.spuShow) {
                return
            }
            this.$refs.area.onShow()
        },
        dyadicArrToObjArr () {
            const areaList = {
                province_list: {},
                city_list: {},
                county_list: {}
            }
            const provinceData = this.getAreaList.province_list
            const cityData = this.getAreaList.city_list
            const countyData = this.getAreaList.county_list
            this.spuSalesAreaList.map(item => {
                areaList.province_list[item.provinceId] = provinceData[item.provinceId]
                if (parseInt(item.cityId)) {
                    areaList.city_list[item.cityId] = cityData[item.cityId]
                    areaList.county_list[item.areaId] = countyData[item.areaId]
                } else {
                    let str = item.provinceId.substring(0, 2)
                    for (let key in cityData) {
                        if (key.substring(0, 2).indexOf(str) !== -1) {
                            areaList.city_list[key] = cityData[key]
                            areaList.county_list[key] = cityData[key]
                        }
                    }
                }
            })
            let isCity = Object.keys(areaList.city_list).indexOf(this.areaArray.cityId)
            if (isCity >= 0) {
                this.addressName = this.areaArray.provinceName + ' ' + this.areaArray.cityName + (this.spuShow ? ' ' + this.areaArray.countryName : '')
            } else {
                this.addressName = areaList.province_list[Object.keys(areaList.province_list)[0]] + ' ' + areaList.city_list[Object.keys(areaList.city_list)[0]] + (this.spuShow ? ' ' + areaList.county_list[Object.keys(areaList.county_list)[0]] : '')
            }
            this.areaList = areaList
            this.showValue = true
        },
        async getAreaData () {
            const { data } = await getBusinessArea({
                companyCode: this.userInfo.companyCode
            })
            this.areaArray = data
        }
    },
    async created () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
        let areaData = localStorage.getItem('areaList') ? JSON.parse(localStorage.getItem('areaList')) : ''
        if (!this.spuSalesAreaList.length) {
            this.addressName = '所在区域无此商品可售'
            return
        }
        if (this.userInfo.companyCode) {
            await this.getAreaData()
        }
        !areaData && await this.getArea()
        this.$nextTick(() => {
            this.dyadicArrToObjArr()
        })
    }
}
</script>
<style lang='scss' scoped>
.mark {
    font-size: 28px;
    position: relative;
    background-color: #ffffff;
    height: 96px;
    line-height: 96px;
    padding: 0 32px;
    overflow: hidden;
    .item {
        float: right;
        margin-right: 40px;
        width: 480px;
        color: #333333;
        text-align: left;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
    }
}
/deep/ .van-picker__cancel {
    width: 120px;
}
</style>